import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    justify-content: start;
    grid-template-columns: auto 1px auto;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km10};
    margin-top: ${spacing.km4};
    width: 100%;
  `}
`;

export const Item = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km3};
  `}
`;

export const LogoList = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    align-items: center;
    grid-gap: ${spacing.km8};
    height: 2rem;
  `}
`;
